export var judgeCurrentQuoteIsEquivalentByServerData = function judgeCurrentQuoteIsEquivalentByServerData(data) {
  var _data$currency_exchan;

  return !!(data !== null && data !== void 0 && (_data$currency_exchan = data.currency_exchange_rate) !== null && _data$currency_exchan !== void 0 && _data$currency_exchan.is_equivalent);
};